/**
 * Base service utilities
 * Sprint 6 – Standardized Data Access Layer
 */
import { supabase } from '@/core/database/supabase';

export { supabase };

export type ServiceResult<T> = {
  data: T | null;
  error: string | null;
};

export type PaginatedResult<T> = {
  data: T[];
  count: number;
  error: string | null;
};

export function handleError(error: unknown): string {
  console.error('[Database Error]', error);
  if (typeof error === 'object' && error !== null && 'code' in error) {
    const code = (error as any).code;
    if (code === '23505') return 'Dữ liệu này đã tồn tại trong hệ thống. Vui lòng kiểm tra lại.';
    if (code === '23503') return 'Không thể xóa vì dữ liệu này đang được tham chiếu ở nơi khác.';
    if (code === '42501') return 'Bạn không có quyền thực hiện thao tác này.';
    if (code === 'PGRST116') return 'Không tìm thấy dữ liệu yêu cầu.';
  }
  if (error instanceof Error) return error.message;
  if (typeof error === 'object' && error !== null && 'message' in error) {
    return String((error as { message: unknown }).message);
  }
  return 'Đã xảy ra lỗi không xác định. Vui lòng thử lại.';
}

export type SortOrder = 'asc' | 'desc';

export interface PaginationParams {
  page?: number;
  pageSize?: number;
}

export function getPaginationRange(page = 1, pageSize = 20): { from: number; to: number } {
  const from = (page - 1) * pageSize;
  const to = from + pageSize - 1;
  return { from, to };
}
